import React, { useState, useContext, useEffect, useCallback, useRef } from 'react';
import StoreProductHeader from '../StoreProductHeader/StoreProductHeader';
import StoreProductGrid from '../StoreProductGrid/StoreProductGrid';
// import StoreProductFilter from '../StoreProductFilter/StoreProductFilter';
import UserContext from '../../../common/utils/getContext';
// import { useWindowDimensions } from '../../../common/utils/windowDimensions';
import PropTypes from 'prop-types';
import css from './StoreProduct.module.scss';
import { LangContext } from '../../../common/decorators/Language';
import { t } from '../../../common/components/T';
import { API_SERVER_URL } from '../../../common/utils/utils';
// import Skeleton from '../../plug/Skeleton/Skeleton';

const StoreProduct = ({ mixStyles, product, category, qSearch, isLoadingPrice }) => {
    const { lang, profile } = useContext(UserContext);
    const { translation } = useContext(LangContext) || {};
    const compStyles = { ...css, ...mixStyles };
    const [productData, setProductData] = useState(product);

    const selectPageItems = ['25', '50', '75', '100'];
    const [selectedLengthItems, setSelectedLengthItems] = useState('1000');
    const selectPageItemsSort = [
        {
            value: '-price',
            label: t('selectPageItemsSort_-price-v1', 'Дороже', '/store', translation)
        },
        {
            value: 'price',
            label: t('selectPageItemsSort_price-v1', 'Дешевле', '/store', translation)
        }
    ];
    const [selectedSortItem, setSelectedSortItems] = useState('-price');

    // const originUrl = useRef(new URL(`${API_SERVER_URL}/api/v1/shop/products`));

    const url = useRef(new URL(`${API_SERVER_URL}/api/v1/shop/products`));

    // const getOriginUrl = useCallback(() => {
    //     return originUrl.current;
    // }, []);

    const getUrl = useCallback(() => {
        return url.current;
    }, [url]);

    // const setUrl = useCallback((newUrl) => {
    //     url.current = newUrl;
    // }, []);

    const getTransformedOriginUrlWithHeaderParams = useCallback(
        (originUrl_) => {
            let originUrl = originUrl_;
            if (qSearch) {
                originUrl.searchParams.set('filter[q]', qSearch);
            }
            if (category?.data?.product_count || category?.data?.id) {
                originUrl.searchParams.set(
                    `filter[${category?.data?.product_count ? 'categories' : 'category_descendants'}]`,
                    category?.data?.id || null
                );
            }
            originUrl.searchParams.set('include', 'media,special_statuses');
            originUrl.searchParams.set('page[size]', selectedLengthItems);
            originUrl.searchParams.set('sort', selectedSortItem);
            if (profile?.country?.geoname_id) {
                originUrl.searchParams.set('filter[country_id]', profile?.country?.geoname_id);
            }

            return originUrl;
        },
        [category?.data?.id, category?.data?.product_count, qSearch, selectedLengthItems, selectedSortItem, profile]
    );

    useEffect(() => {
        let originUrl = url.current;
        url.current = getTransformedOriginUrlWithHeaderParams(originUrl);
    }, [
        category.data.id,
        category.data.product_count,
        category.id,
        category.product_count,
        getTransformedOriginUrlWithHeaderParams,
        qSearch,
        selectedLengthItems,
        selectedSortItem
    ]);

    useEffect(() => {
        setProductData(product);
    }, [product]);
    // const widthDimensions = useWindowDimensions();
    // const [mobile, setMobile] = useState('');
    // useEffect(() => {
    //     widthDimensions < 992 ? setMobile(true) : setMobile(false);
    // }, [widthDimensions]);
    // const changeCount = useCallback((count) => {
    //     setCountProduct(count);
    // }, []);

    // const handlersFilters = useMemo(() => ({ count: changeCount }), [changeCount]);
    return (
        <div>
            <div className={compStyles.storeProductWrapper}>
                <StoreProductHeader
                    compStyles={compStyles}
                    setProductData={setProductData}
                    // setFilterMobile={setFilterMobile}
                    selectedLengthItems={selectedLengthItems}
                    setSelectedLengthItems={setSelectedLengthItems}
                    selectPageItems={selectPageItems}
                    selectPageItemsSort={selectPageItemsSort}
                    setSelectedSortItems={setSelectedSortItems}
                    selectedSortItem={selectedSortItem}
                    getUrl={getUrl}
                />
                {/* <Skeleton
                    wrapperStyles={mobile ? '' : compStyles.storeProductFilter}
                    elements={
                        mobile
                            ? []
                            : [
                                  'empty',
                                  {
                                      row: [3, 94, 3],
                                      items: ['empty', 'blockSM']
                                  },
                                  'empty',
                                  {
                                      row: [3, 94, 3],
                                      items: ['empty', 'blockSM']
                                  }
                              ]
                    }
                    wait={Boolean(propertiesFilters)}
                    Component={StoreProductFilter}
                    componentProps={{
                        qSearch: qSearch,
                        compStyles: compStyles,
                        productData: productData,
                        setProductData: setProductData,
                        category: category,
                        countProduct: countProduct,
                        mobile: mobile,
                        propertiesFilters: propertiesFilters,
                        filterMobile: filterMobile,
                        setFilterMobile: setFilterMobile,
                        handlers: handlersFilters,
                        selectedLengthItems: selectedLengthItems,
                        selectedSortItem: selectedSortItem,
                        getOriginUrl: getOriginUrl,
                        getTransformedOriginUrlWithHeaderParams: getTransformedOriginUrlWithHeaderParams,
                        setUrl: setUrl
                    }}
                /> */}
                <StoreProductGrid
                    compStyles={compStyles}
                    productData={productData}
                    setProductData={setProductData}
                    isLoadingPrice={isLoadingPrice}
                    lang={lang}
                    category={category}
                    selectedLengthItems={selectedLengthItems}
                />
            </div>
        </div>
    );
};
StoreProduct.propTypes = {
    mixStyles: PropTypes.object,
    product: PropTypes.object,
    category: PropTypes.object
};
export default StoreProduct;
